import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		saveRow: {
			textAlign: "right",
		},
		mainImage: {
			width: 370, 
			height: 190, 
			marginTop:40, 
			objectFit: "cover"
		}
	} satisfies Record<string, CSSObject>;
};